// CRC-32 (IEEE 802.3) → base64,与 AWS S3 ChecksumCRC32 一致。
// 2026-06-24:改用 hash-wasm crc32(WASM,接近原生);分片 Upload-Checksum 用。
// ⚠️ 编码与后端 chunkCRC32Base64 逐字节一致(known-vector 测试守护,见 crc32.test.ts +
//    server/internal/upload/chunk_crc32_test.go);hash-wasm 返回 8 位 hex(大端表示)。
import { crc32 as crc32Hex } from 'hash-wasm'

// crc32Base64 计算 bytes 的 CRC-32 → 4 字节大端 → base64(AWS ChecksumCRC32 格式)。
export async function crc32Base64(bytes: Uint8Array): Promise<string> {
  const hex = await crc32Hex(bytes) // 8 位小写 hex
  const buf = Uint8Array.from(hex.match(/../g)!.map((h) => parseInt(h, 16)))
  let bin = ''
  for (const b of buf) bin += String.fromCharCode(b)
  return btoa(bin)
}
